import { createFileRoute } from "@tanstack/react-router";
import ProductReviewService from "@/pages/ProductReviewService";

export const Route = createFileRoute("/product-review-service")({
  component: ProductReviewService,
});
